<template>
  <div class="incoming-call">
    <button
      class="button-close"
      @click="close"
    >
      <font-awesome-icon
        icon="times"
        color="#fff"
      />
    </button>
    <div class="icon">
      <icon-sushifox />
    </div>
    <span class="incoming-call-title font-weight-medium">{{ title }}</span>
    <div class="incoming-call-info">
      <div class="client mb-4">
        <span class="label">Клиент</span>
        <span class="client-name font-weight-medium">{{ clientName }}</span>
      </div>
      <div
        v-if="callEvent.ordersInProgress.length"
        class="orders"
      >
        <span class="label">Активные заказы</span>
        <a
          v-for="order in callEvent.ordersInProgress"
          :key="order.id"
          class="order-link mb-1"
          @click="openFastOrder(order.id)"
        >
          <span class="order-number font-weight-medium">№{{ order.code }}</span>
          <span class="order-number font-weight-medium"> ({{ getStatusName(order.order_status) }})</span>
        </a>
      </div>
    </div>
    <v-btn
      v-if="showButtonOrder"
      class="apply-button"
      height="60px"
      block
      dark
      depressed
      @click="answerPhone"
    >
      <font-awesome-icon
        color="#ffffff"
        width="19px"
        icon="plus"
      />
      Новый заказ
    </v-btn>
  </div>
</template>

<script>
  import IconSushifox from '@/components/icons/IconSushifox.vue'
  import OrderStatus from '@/models/enums/OrderStatus'
  import editSessionApi from '@/api/order/edit-session'

  // accountId: 2000
  // callId: '1613-157424-448397'
  // clientId: 0
  // clientName: ''
  // clientPhone: '79135700981'
  // hasOrdersToday: false
  // incomingPhone: '78123381100'
  // isActiveClient: false
  // socket: null

  export default {
    name: 'IncomingCall',
    components: {
      IconSushifox,
    },
    props: {
      value: Boolean,
      callEvent: {
        type: Object,
        default: () => ({}),
      },
      showButtonOrder: Boolean,
    },
    computed: {
      title () {
        return this.callEvent.isCallback ? 'Звонок клиенту' : 'Входящий звонок'
      },
      clientName () {
        return this.callEvent.clientName
          ? `${this.callEvent.clientName} (${this.callEvent.clientPhone})`
          : this.callEvent.clientPhone
      },
    },
    methods: {
      close () {
        this.$emit('input', false)
      },
      answerPhone () {
        this.$store.commit('newOrder/setNewClientPhone', this.callEvent.clientPhone)
        if (this.callEvent.isActiveClient) {
          this.$store.commit('newOrder/setActiveClientId', this.callEvent.clientId)
        }
        this.$router.push('/new-order').then(() => this.close())
      },
      getStatusName (status) {
        return OrderStatus.getName(status).toLowerCase()
      },
      openFastOrder (id) {
        editSessionApi.open(id)
        this.$router.push({ path: '/fast-order', query: { id } }).then(() => this.close())
      },
    },
  }
</script>

<style lang="less" scoped>
.order-link {
  text-decoration: underline;
  color: #fff;
  display: block;
}

.incoming-call {
  min-height: 277px;
  padding: 38px 33px 23px 33px;
  position: fixed;
  right: 20px;
  bottom: 100px;
  background-color: #0033ff;
  border-radius: 10px;
  max-width: 450px;
  width: 100%;
  z-index: 10000;

  .button-close {
    position: absolute;
    right: 18px;
    top: 18px;
    width: 32px;
    height: 32px;
    svg {
      width: 24px;
      height: 24px;
    }
  }

  .icon {
    position: absolute;
    right: 19px;
    bottom: 12px;
    z-index: -1;
    svg {
      height: 240px;
      width: 234px;
      ::v-deep {
        .fill-svg(#0008ff);
      }
    }
  }

  .incoming-call-title {
    display: block;
    color: #ffffff;
    font-size: 29px;
    line-height: 1;
    margin-bottom: 35px;
  }

  .label {
    display: block;
    font-size: 14px;
    line-height: 19px;
    color: #ffffff;
  }

  .incoming-call-info {
    margin-bottom: 43px;

    .client-name {
      color: #ffffff;
      font-size: 29px;
      line-height: 1;
    }

    .order-number {
      font-size: 20px;
      line-height: 29px;
      color: #ffffff;
    }
  }

  .apply-button {
    border-radius: 100px;
    background-color: @color-primary !important;
    color: #ffffff;
    font-size: 16px;

    svg {
      margin-right: 12px;
      height: 18px;
      width: 18px;
      .fill-svg(#ffffff);
    }
  }
}
</style>
